import { Container } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import Header from '../../../../shared/components/Header'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import useScreenWidthView from '../../../../shared/hooks/useScreenWidth'
import SubHeader from '../../../../shared/styles/Subheader'
import CoursesContentCards from '../components/CoursesContentCards'
import CoursesType from '../components/CoursesType'
import useHandleData from '../hooks/useHandleData'
import useHandleFilters from '../hooks/useHandleFilters'
import useHandlePagination from '../hooks/useHandlePagination'

function CourseList() {
  const { t } = useTranslation(['global'])

  const isMobile = useScreenWidthView(750)
  const isTablet = useScreenWidthView(1000)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()

  const { filters, handleChangeFilter, handleContentSearch } = useHandleFilters()
  const { coursetypes, courses, coursesProgress, loading } = useHandleData()

  const { rowsPerPage, nextPage, resetPage } = useHandlePagination({ filters })

  useEffect(() => {
    resetPage()
  }, [filters])

  return (
    <>
      {loadingSkeleton && componentSkeleton}

      <div style={{ display: loadingSkeleton ? 'none' : 'block' }}>
        <Header title={t('academy')} />

        <SubHeader>
          <CoursesType coursetypes={coursetypes} filterId={filters.coursetype_id} handleChangeFilter={handleChangeFilter} />
        </SubHeader>
        <ContentFilter sectionName={t('courses')} handleContentSearch={handleContentSearch} />

        <Container id="courses-client-container" style={{ maxWidth: 1111 }}>
          <CoursesContentCards
            authUser={authUser}
            courses={courses}
            coursesProgress={coursesProgress}
            loading={loading}
            isMobile={isMobile}
            isTablet={isTablet}
            rowsPerPage={rowsPerPage}
            onNextPage={nextPage}
          />
        </Container>
      </div>
    </>
  )
}

export default CourseList
